import Vue from 'vue'
import Vuex from 'vuex'
import { getPlatform } from '@/utils/judge'
import createVuexAlong from 'vuex-along'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountId: '',
    platform: getPlatform(), // 判断设备
    initTelphone: {
      // dialCode: 86,
      code: 'cn',
      name: '中国',
      no: '86',
      phoneFormat: '131 2345 6789'
    }
  },
  mutations: {
    SET_InitTelphone: (state, initTelphone) => {
      state.initTelphone = initTelphone
    }
  },
  actions: {
    setInitTelphone({ commit }, initTelphone) {
      commit('SET_InitTelphone', initTelphone)
    }
  },
  plugins: [createVuexAlong({
    name: 'vuex-non-along', // 设置保存的集合名字，避免同站点下的多项目数据冲突
    local: {
      list: ['initTelphone'],
      isFilter: true // 过滤模块 open 数据
    },
    session: {
      list: ['initTelphone'] // 保存 open
    },
    justSession: true
  })]
})
